export default {
  computed: {
    isInvalid() {
      return Object.values(this.invalidFields).includes(true)
    },
  },

  methods: {
    onInput(field, value) {
      this.formData[field] = value
      this.$emit('input', { [field]: value })
    },
    onInvalid(data) {
      this.invalidFields[data.name] = data.invalid
      if (data.invalid) {
        this.$emit('invalid', true)
      }
    },
    onPrev() {
      this.$emit('form:prev')
    },
    onNext() {
      this.$emit('form:next')
    },
  },
}
